// @flow
import * as React from 'react'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import type { AppStateType } from '../reducers/appstate'
import { withRouter } from 'next/router'
import {
  fetchFinePrintPage
} from '../services/contentfulPosts'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import styled from 'styled-components'
import { colors } from '@components/shared'
import { config } from 'react-awesome-styled-grid'
import HtmlHead from '@components/HtmlHead'

type PropsType = {
  privacyPolicyPageInfo: any
}

function PrivacyPolicy (props: PropsType): React.Node {
  return (
    <Wrapper>
      <HtmlHead title={'Dipsea | Privacy Policy'}/>
      <ContentStyled>
        {documentToReactComponents(props.privacyPolicyPageInfo)}
      </ContentStyled>
    </Wrapper>
  )
}

export async function getStaticProps (): Promise<{ props: PropsType }> {
  const privacyPolicyPageInfo = await fetchFinePrintPage('privacypolicy')

  return {
    props: {
      privacyPolicyPageInfo
    }
  }
}

const mapStateToProps = (state: AppStateType, ownProps: PropsType): any => {
  return ownProps
}

const mapDispatchToProps = (dispatch: Dispatch<any>): any => {
  return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PrivacyPolicy))

const Wrapper = styled.div`
  background-color: ${colors.midnightBlue};
`

const ContentStyled = styled.div`
color: #F6F3F0;
font-family: 'Good Sans Light';
min-height: 100vh;
position: relative;
box-sizing: border-box;
padding: 56px 20px;
max-width: 1094px;
margin: 0 auto;
${(props: any): string => config(props).media.md`
  padding: 88px 70px;
`}
${(props: any): string => config(props).media.lg`
  padding: 96px 60px;
`}
${(props: any): string => config(props).media.xl`
  padding: 100px 173px;
`}
div {
  margin: 0 auto;
  max-width: 1000px;
  padding: 60px 20px;
}
h1 {
  font-size: 36px;
  line-height: 120%;
  font-weight: 300;
  letter-spacing: -0.5px;
  font-family: 'Queens Condensed Regular';
  padding: 0 0 .25em;
  margin: 0px 0 28px;
  ${(props: any): string => config(props).media.md`
    font-size: 45px;
  `}
  ${(props: any): string => config(props).media.lg`
    font-size: 60px;
    line-height: 110%;
  `}
}
h2 {
  font-size: 22px;
  font-weight: bold;
  line-height: 1.5em;
  padding-top: 17px;
  letter-spacing: -0.5px;
  ${(props: any): string => config(props).media.lg`
    font-size: 24px;
    line-height: 150%;
  `}
}
h3 {
  font-size: 18px;
  font-weight: 800;
  line-height: 22px;
}
h4 {
  font-size: 16px;
  font-weight: 800;
  line-height: 20px;
}
h5, h6 {
  font-size: 14px;
  font-weight: 800;
  line-height: 1.25em;
}
ol, li, ul {
  font-size: 14px;
  line-height: 1.25em;
  list-style-type: circle;
  margin: 0 0 1em;
  padding-inline-start: 20px;
  ol, li, ul {
    list-style-type: circle;
    margin: 0 0 1em;
    padding-inline-start: 10px;
  }
}
p {
  font-size: 16px;
  line-height: 150%;
  margin: 0 0 22px 0;
  b {
    font-weight: bold;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0.4px;
    ${(props: any): string => config(props).media.lg`
      font-size: 18px;
      line-height: 150%;
    `}
  }
}
a {
  color: #BF105F;
  font-weight: 700;
  :hover {
    opacity: 0.75;
  }
}
strong {
  font-weight: 800;
}
animation: fade-in .5s ease-in both;
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`
